<template>
    <HeaderCardsLayout variant="No-Logo">
        <template #breadcrumbs></template>
        <template #headline>{{ $t('external-event-add') }}</template>
        <template #breadcrumb>
            <Breadcrumb :headline="$t('breadcrumb')" :current-page="$t('external-event-add')">
                <BreadcrumbLink :target="{ name: 'external-events' }">
                    <AirplaneIcon class="mr-1 shrink-0" />
                    {{ $t('external-events') }}
                </BreadcrumbLink>
                <BreadcrumbLink :target="{ name: 'external-event-series', params: { seriesId: seriesId } }">
                    {{ props.nameLong }}
                </BreadcrumbLink>
            </Breadcrumb>
        </template>
        <template #body>
            <PaddedContentTop>
                <div class="bg-gray-50">
                    <div class="px-4 pb-4 pt-4">
                        <ExternalEventEventCreateForm :series-id="seriesId" />
                    </div>
                </div>
            </PaddedContentTop>
        </template>
    </HeaderCardsLayout>
</template>
<script setup lang="ts">
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue';
import BreadcrumbLink from '@/components/Breadcrumb/BreadcrumbLink.vue';
import AirplaneIcon from '@/components/Icon/AirplaneIcon.vue';
import HeaderCardsLayout from '@/components/Layout/HeaderCardsLayout.vue';
import PaddedContentTop from '@/components/Layout/PaddedContentTop.vue';
import { $t } from '@/plugins/fluent';
import { useHeadSafe } from '@unhead/vue';
import ExternalEventEventCreateForm from '../forms/ExternalEventEventCreateForm.vue';

const props = defineProps<{ seriesId: string; nameShort: string; nameLong: string }>();

useHeadSafe({ title: () => `${$t('external-event-add')} - ${props.nameShort} - ${$t('external-events')}` });
</script>
